import type { ReactNode } from 'react';

import { Badge } from '@mantine/core';

const MAX_SHOWN = 99;

/**
 * The count pill a nav item carries when something behind it needs
 * someone: nothing at zero or before the first read, "99+" past 99.
 *
 * A function rather than a component: a Button or Menu.Item given an
 * element that renders nothing still lays out an empty section for it.
 */
export function navCountBadge(
  count: number | null | undefined,
  testId: string,
  title?: string
): ReactNode {
  if (count == null || count <= 0) {
    return undefined;
  }
  return (
    <Badge size="sm" circle color="yellow" c="navy" title={title} data-testid={testId}>
      {count > MAX_SHOWN ? `${MAX_SHOWN}+` : count}
    </Badge>
  );
}
